export interface PowerDialerPreferenceSnapshot {
  autoProgress?: boolean | null
  personalListSequenceId?: number | string | null
  powerDialerTargetId?: number | string | null
  powerDialerTargetType?: string | null
  snoozeTime?: number | string | null
  todoListSequenceId?: number | string | null
}

export function toPositiveNumber(value: number | string | null | undefined) {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null
}

export function toFiniteNumber(value: number | string | null | undefined) {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function hasSnapshotPowerDialerSelection(preferences: PowerDialerPreferenceSnapshot) {
  return Boolean(toPositiveNumber(preferences.powerDialerTargetId))
}

export function getSnapshotTargetLabel(preferences: PowerDialerPreferenceSnapshot) {
  const targetId = toPositiveNumber(preferences.powerDialerTargetId)

  if (!targetId) {
    return "Select your target to work on..."
  }

  if (targetId === toPositiveNumber(preferences.personalListSequenceId)) {
    return "Personal List"
  }

  if (targetId === toPositiveNumber(preferences.todoListSequenceId)) {
    return "To-do List"
  }

  return "Selected target"
}
